// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__17lmE","withMobileMargins":"DateRangeInput_withMobileMargins__3UZ0V","arrowIcon":"DateRangeInput_arrowIcon__OL-SU"};